<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="degrees"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.level`]="{ item }">
              {{ showLevel(item) }}
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item.active) }}
              </v-chip>
            </template>
            <template #[`item.short_name`]="{ item }">
              <span
                @click="navigate(item)"
                style="
                  cursor: pointer;
                  color: #4f4584;
                  text-decoration: underline;
                "
                >{{ item.short_name }}</span
              >
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createDegree"
        @update="updateDegree"
        :degree="degree"
        :edit="editMode"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="degree"
      :name="currentItem.short_name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/degree/form.vue";
import searchBar from "@/components/searchBar.vue";
import { degreeHeaders } from "@/constants/headers";
import { levels } from "@/constants/enum";
import ConfirmDialog from "@/components/confirm.vue";
export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      degree: {},
      currentItem: {},
      showDialog: false,
      degrees: [],
      search: "",
      headers: degreeHeaders,
      levels: levels,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Degree" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      this.getDegrees();
    },
    async getDegrees() {
      await this.$axios
        .get("degrees")
        .then((res) => {
          this.degrees = res.data.data.sort((a, b) => b.id - a.id);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async createDegree(data) {
      await this.$axios
        .post("degrees", { degree: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Degree created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateDegree(data) {
      await this.$axios
        .put("degrees/" + data.id, { degree: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Degree updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      this.updateDegree({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item};
    },

    edit(item) {
      this.degree = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.currentItem = {};
      this.degree = {};
    },
    showLevel(item) {
      return this.levels.find((i) => i.id === item.level)?.name;
    },
    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const level = this.showLevel(item);
      const activeStatus = this.showActiveStatus(item.active);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        level.toLowerCase().includes(search.toLowerCase()) ||
        activeStatus.toLowerCase().includes(search.toLowerCase())
      );
    },
    navigate(item) {
      this.$router.push({
        path: `/programs/${item.id}/degrees`,
        query: {
          name: `${item.short_name}`,
        },
      });
    },
  },
};
</script>

<style></style>
